import React from "react";
import {Icon,Col,Row} from "antd";

const PercentDrawer = (props) => {
	return (
		<div style={{ justifyContent: "space-between",display:"flex"  }}>
			<div><Icon style={{ paddingRight: 5 }} type={props.icon} />{props.text}</div>
			<div style={{ textAlign: "right",display:"inline-flex"}}>
				<div>
					{props.value}
				</div>
				<div style={{width:100}}>
					{props.percent}
				</div>
			</div>
		</div>
	);
};

export default PercentDrawer;






// WEBPACK FOOTER //
// ./src/components/form/PercentDrawer.js